export const PURCHASE_TYPE = {
  NEW: 1,
  UPGRADE: 2,
  EXTEND: 3 // free --> buy
};

export const OLD_VERSION_PURCHASE_MODE_NAMES = {
  [PURCHASE_TYPE.NEW]: "خرید طرح",
  [PURCHASE_TYPE.UPGRADE]: "ارتقا امکانات",
  [PURCHASE_TYPE.EXTEND]: "تمدید طرح"
};
export const PURCHASE_MODE_NAMES = {
  [PURCHASE_TYPE.NEW]: "خرید طرح",
  [PURCHASE_TYPE.UPGRADE]: "تغییر طرح",
  [PURCHASE_TYPE.EXTEND]: "تمدید طرح"
};

export const PURCHASE_STEPS_TYPE = {
  CHOOSE_PLAN: 2,
  CONFIRM_PLAN: 3,
  FINAL_PAYMENT: 4
};
export const PURCHASE_STEPS_TYPE_TEXT = [
  { type: PURCHASE_STEPS_TYPE.CHOOSE_PLAN, text: "انتخاب طرح" },
  { type: PURCHASE_STEPS_TYPE.CONFIRM_PLAN, text: "تایید طرح" },
  { type: PURCHASE_STEPS_TYPE.FINAL_PAYMENT, text: "پرداخت نهایی" }
];

export const PURCHASE_USED_KEY = {
  FORM_STEP: "FORM_STEP",
  PROJECT_ID: "PROJECT_ID",
  PROJECT_NAME: "PROJECT_NAME",
  PLAN_ID: "PLAN_ID",
  DURATION_ID: "DURATION_ID",
  PURCHASE_ACTION: "PURCHASE_ACTION",
  OWNER_ID: "OWNER_ID",
  APPLIED_LIMITS: "APPLIED_LIMITS",
};
